import React from "react";
import AuditLogView from "@/components/AuditLogView";

// Jurnalul complet al platformei — vizibil DOAR rolului Admin (backend:
// core/users.py:get_audit, hardcodat, nu configurabil din Permisiuni).
export default function Audit() {
  return <AuditLogView endpoint="/audit" title="Jurnal de audit"
    subtitle="Toate operațiunile din platformă: cine, ce acțiune, când și de la ce adresă IP." />;
}
